import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  publishedAt: string;
  isHot?: boolean;
  isTop?: boolean;
  views?: number;
}

export default function ArticleCard({
  id,
  title,
  category,
  categorySlug,
  imageUrl,
  imageWidth,
  imageHeight,
  publishedAt,
  isHot,
  isTop,
  views,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block shrink-0 w-[280px] md:w-[320px] cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-2xl bg-background-100 mb-4">
        <div
          className="w-full"
          style={{ aspectRatio: `${imageWidth}/${imageHeight}` }}
        >
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 91在线吃瓜网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        {(isHot || isTop) && (
          <div className="absolute top-3 left-3 flex gap-1.5">
            {isTop && (
              <span className="px-2 py-0.5 text-[11px] font-bold rounded-md bg-primary-500 text-background-50">
                置顶
              </span>
            )}
            {isHot && (
              <span className="px-2 py-0.5 text-[11px] font-bold rounded-md bg-accent-500 text-background-50">
                热门
              </span>
            )}
          </div>
        )}
      </div>
      <h3 className="text-foreground-50 text-sm md:text-base font-bold leading-snug group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <Link
          to={`/category/${categorySlug}`}
          className="text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
          onClick={(e) => e.stopPropagation()}
        >
          {category}
        </Link>
        <span className="text-foreground-600">|</span>
        <span>{publishedAt}</span>
        {views !== undefined && (
          <>
            <span className="text-foreground-600">|</span>
            <span>{views.toLocaleString()} 次围观</span>
          </>
        )}
      </div>
    </Link>
  );
}